<div class="header-top-menu">
  <div class="g-container">
    <div class="header-top-menu-content">
      <service-menu class="header-top-menu-service" />

      <div class="header-top-menu-phones header-phones">
        <div class="header-phones-content">
          @for (phoneNumber of MANAGER_PHONES; track phoneNumber) {
            <a
              class="header-phones-link"
              [href]="'tel:' + phoneNumber"
            >
              {{ phoneNumber | mask:PHONE_NUMBER_MASK }}
            </a>
          }
          <i class="mbi mbi-ios-arrow-down header-phones-arrow"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="header-main">
  <div class="g-container">
    <div class="header-main-content">
      <a
        class="header-logo"
        routerLink="/"
        routerLinkWithLang
      >
        <img
          class="header-logo-img"
          src="../../../assets/images/logo.png"
          alt="Klondike"
          loading="eager"
        >
        <span class="header-logo-text">{{ 'header.slogan' | translate }}</span>
      </a>

      <div
        class="header-catalog-toggle"
        (click)="toggleHeaderCatalogMenu()"
        (clickOutside)="toggleHeaderCatalogMenu(true)"
      >
        <div
          class="header-catalog-toggle-btn"
          [class.header-catalog-toggle-btn-active]="isHeaderCatalogMenuVisible()"
        >
          <tc-icon class="header-catalog-toggle-btn-icon" name="catalog" />
          <div class="header-catalog-toggle-text">{{ 'header.catalog' | translate }}</div>
        </div>

        @if (isHeaderCatalogMenuVisible()) {
          <catalog-menu
            class="header-catalog-toggle-menu"
            [categories]="categoryService.categories()"
            (menuMouseLeave)="onMenuMouseLeave()"
          />
        }
      </div>

      <div
        class="header-toolbar-wrap"
        [class.header-toolbar-wrap-catalog]="isSidebarCatalog()"
      >
        <div
          class="header-toolbar"
          [class.header-toolbar-search-opened]="isSearchBarInFocus()"
          [style.top.px]="toolbarService.announcementElHeight()"
          #toolbarRef
        >
          <div
            class="header-toolbar-menu-btn"
            (click)="openMenu()"
          >
            <i class="mbi mbi-menu header-toolbar-menu-icon"></i>
          </div>

          <search-bar
            class="header-toolbar-search"
            (isSearchBarInFocus)="setIsSearchBarInFocus($event)"
          />


          <lang-selector class="header-toolbar-lang" />

          <a
            class="header-toolbar-item wishlist"
            [routerLink]="['/wishlist']"
            routerLinkWithLang
          >
            <tc-icon
              class="header-toolbar-item-icon"
              name="heart"
            />
            @if (wishlistService.wishlistProductIds().length; as count) {
              <div class="header-toolbar-item-count">
                {{ count }}
              </div>
            }
          </a>

          <div
            class="header-toolbar-item cart"
            (click)="openCart()"
          >
            <tc-icon
              class="header-toolbar-item-icon"
              name="cart"
            />

            @if (cartService.rawCartItemsCount(); as count) {
              <div class="header-toolbar-item-count">{{ count }}</div>
            }
          </div>

          <mini-account class="header-toolbar-item header-toolbar-account" />
        </div>
      </div>
    </div>
  </div>
</div>

<sidebar-menu />
